export const createPath = (path: string) => path.replace(/(\/)\1+/g, '$1')